import { StepRenderer } from './SherlockWorkflowDrawer';

export const balancingFractionalRemoverStepRenderers: Record<string, StepRenderer> = {
  preflightChecks: (step, input, output) => {
    const portfolioKey = input?.portfolioKey;
    const apsKeys = output?.apsKeys || [];
    
    return {
      text: `Preflight checks completed for portfolio ${portfolioKey}`,
      tooltip: `Found ${apsKeys.length} AutoPilot settings. Verified Schwab portfolio and no active balancings.`,
    };
  },

  getDecision: (step, input, output) => {
    type FractionalPosition = { decision: string };
    const fractionalPositions: FractionalPosition[] = output?.fractionalPositions || [];

    const numSimpleSells = fractionalPositions.filter((fp) => fp.decision === 'simple_sell').length;
    const numMultiSells = fractionalPositions.filter((fp) => fp.decision === 'multi_sell').length;
    const numRoundedCorners = fractionalPositions.filter((fp) => fp.decision === 'rounded_corner').length;
    const numTooMuch = fractionalPositions.filter((fp) => fp.decision === 'too_much').length;
    const numNoops = fractionalPositions.filter((fp) => fp.decision === 'noop').length;
    
    return {
      text: `Analysis complete: ${fractionalPositions.length} positions with fractionals`,
      tooltip: `Simple sells: ${numSimpleSells}. Multi sells: ${numMultiSells}. Rounded corners: ${numRoundedCorners}. Too much: ${numTooMuch}. Noops: ${numNoops}.`,
    };
  },

  placeTrades: (step, input, output) => {
    return {
      text: `Sending sell orders for $${input.tradeQueue[0]}`,
      tooltip: `Trade result: ${output.tradeResult}`,
    };
  },

  end: (step, input, output) => {
    return {
      text: 'Workflow completed successfully',
      tooltip: 'All resources have been released and AutoPilot settings un-short-circuited.',
    };
  },

  onError: (step, input, output) => {
    const error = input?.error;
    return {
      text: 'Workflow encountered an error',
      tooltip: `Error details: ${error?.message || 'Unknown error occurred'}`,
    };
  },
};

export const defaultBalancingStepRenderer: StepRenderer = (step, input, output) => {
  // Generic renderer for any balancing workflow step
  const stepName = step.stepName.replace(/([A-Z])/g, ' $1').toLowerCase();
  const formattedStepName = stepName.charAt(0).toUpperCase() + stepName.slice(1);
  
  return {
    text: `${formattedStepName}`,
    tooltip: `Execution ID: ${step.executionId}`,
  };
};
